
import { Progress } from "@/components/ui/progress";

interface LenderLoanRangeProps {
  minLoan?: number;
  maxLoan?: number;
}

export const LenderLoanRange = ({ minLoan = 1000, maxLoan = 50000 }: LenderLoanRangeProps) => {
  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
      maximumFractionDigits: 0
    }).format(amount);
  };
  
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm text-muted-foreground">
        <span>Min: {formatCurrency(minLoan)}</span>
        <span>Max: {formatCurrency(maxLoan)}</span>
      </div>
      <Progress value={100} className="h-1" />
    </div>
  );
};
